import React from "react"
import { Link } from "react-router-dom"
import { ArrowRight, MapPin } from "lucide-react"
import SectionHeading from "./SectionHeading.jsx"

const STRENGTHS = [
  {
    title: "Technical capability",
    text: "Hands-on custom development, integrations and performance work, grounded in modern web technology.",
  },
  {
    title: "Business understanding",
    text: "We start with how your business wins work, then shape the website, search and advertising around it.",
  },
  {
    title: "Delivery experience",
    text: "Clear scope, practical timelines and tidy implementation across websites, SEO and campaigns.",
  },
  {
    title: "Direct relationships",
    text: "You work directly with the person building and supporting your digital presence.",
  },
]

export default function AboutStudio() {
  return (
    <section id="about" aria-labelledby="about-heading" className="scroll-mt-24 bg-brand-bg py-20 sm:py-24">
      <div className="mx-auto grid max-w-6xl gap-12 px-4 sm:px-6 lg:grid-cols-[1.1fr_1fr] lg:items-start">
        <div>
          <SectionHeading
            id="about-heading"
            eyebrow="About 2merative"
            title="An owner-led digital development studio"
          />
          <div className="mt-6 space-y-4 text-lg leading-relaxed text-brand-textSoft">
            <p>
              2merative is an Adelaide digital development studio led by Jason. We treat your
              website and search presence as business infrastructure: solid structure, clear
              conversion paths and systems that scale as your business grows.
            </p>
            <p>
              Our approach is practical. No hype and no jargon, just thoughtful design, careful
              development and straightforward advice about what will make a difference.
            </p>
          </div>
          <p className="mt-6 inline-flex items-center gap-2 text-sm font-medium text-brand-text">
            <MapPin aria-hidden="true" className="h-4 w-4 text-brand-primary" />
            Based in Adelaide, South Australia. Supporting businesses in Adelaide and beyond.
          </p>
          <p className="mt-6">
            <Link
              to="/about"
              className="inline-flex items-center gap-2 font-semibold text-brand-primary hover:underline"
            >
              More about 2merative
              <ArrowRight aria-hidden="true" className="h-4 w-4" />
            </Link>
          </p>
        </div>

        <ul className="grid gap-4 sm:grid-cols-2">
          {STRENGTHS.map((item) => (
            <li key={item.title} className="rounded-xl2 border border-brand-border bg-white p-6 shadow-card">
              <h3 className="font-semibold text-brand-heading">{item.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-brand-textSoft">{item.text}</p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  )
}
